import { Component, computed, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { RestrictedElementDirective } from '@auth';
import { Debounce, EntityStatus } from '@core';
import { ADMIN_DEVICE_TABLE_COLS, DeviceTableCols } from '@devices';
import { TableSearchInputComponent } from '@ui';

import { FiltersStore } from '../../../stores';
import { FiltersBarComponent } from '../filters-bar';

interface Config {
  columnSelectOptions?: { title: string; value: string; }[];
  filtersEnabled?: boolean;
  locationFilter?: boolean;
  reportMode?: boolean;
  statusFilter?: boolean;
}

@Component({
  imports: [
    MatButtonToggleModule,
    MatSelectModule,
    MatTooltip,
    TableSearchInputComponent,
    FiltersBarComponent,
    RestrictedElementDirective,
  ],
  providers: [FiltersStore],
  selector: 'avs-filters-panel',
  templateUrl: './filters-panel.component.html',
})
export class FiltersPanelComponent implements OnInit {
  columns = input<string[]>([]);
  columnsChanged = output<string[]>();
  filters = input<Record<string, string>>();
  filtersChanged = output<Record<string, string | string[]>>();
  inputConfig = input.required<Config>({ alias: 'config' });
  tableId = input.required<string>();

  protected config = computed(() => {
    return {
      ...this.inputConfig(),
      filtersEnabled: this.inputConfig().filtersEnabled ?? true,
      locationFilter: this.inputConfig().locationFilter ?? true,
      reportMode: this.inputConfig().reportMode ?? false,
      statusFilter: this.inputConfig().statusFilter ?? true,
    };
  });

  protected columnSelectOptions = computed(() => {
    return this.config().columnSelectOptions?.map(option => ({
      ...option,
      isAdminColumn: ADMIN_DEVICE_TABLE_COLS.includes(option.value as DeviceTableCols),
    }));
  });

  protected eEntityStatus = EntityStatus;
  protected filtersStore = inject(FiltersStore);
  protected selectedColumns = signal<string[]>([]);

  constructor() {
    effect(() => this.columnsChanged.emit(this.selectedColumns()));
  }

  ngOnInit() {
    this.selectedColumns.set(this.columns());
  }

  protected selectAllColumns() {
    this.selectedColumns.set(
      this.config().columnSelectOptions!.map(({ value }) => value),
    );
  }

  @Debounce()
  protected updateQuery(query: string) {
    this.filtersStore.patchFilters({ query });
  }
}
